import {
  sagaListSuccess,
  sagaOneSuccess,
  sagaUpdateSuccess,
  sagaCreateSuccess
} from "../actions/ActionTypes";

const MEMBERS = "members";
const MEMBER = "member";
const initialState = { list: [], currentMember: {} };
export default function members(state = initialState, action = {}) {
  switch (action.type) {
    case sagaListSuccess(MEMBERS):
      return { ...state, list: action.data.data };
    case sagaOneSuccess(MEMBER):
      return { ...state, currentMember: action.data.data };
    case sagaCreateSuccess(MEMBER):
      return { ...state, currentMember: action.data.data };
    case sagaUpdateSuccess(MEMBER):
      return { ...state, currentMember: action.data.data };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/members.js